import React from 'react';
import esriStrings from '../../resources/esriStrings';
import './viewToggle.scss';

const ViewToggle = (props) => {
  const toggleRef = React.useRef();

  return (
    <div className="view-toggle" ref={toggleRef}>
      <div
        className={`view-toggle-option view-toggle-option-map ${
          props.activeView === 'map' ? ' view-toggle-active' : ''
        }`}
        onClick={() => props.setActiveView('map')}
      >
        {esriStrings.map}
      </div>
      <div
        className={`view-toggle-option view-toggle-option-map ${
          props.activeView === 'data' ? ' view-toggle-active' : ''
        }`}
        onClick={() => props.setActiveView('data')}
      >
        {esriStrings.data}
      </div>
    </div>
  );
};

export default ViewToggle;
